import React from 'react';
import Component from './Component';
import Input from './TextInput';
import {time2string, string2time} from '../../helpers/time';

export default class TimeInput extends Component {

	constructor(props) {
		super(props);
		let value;
		if (typeof props.value != 'undefined') {
			value = time2string(props.value);
		}
		else {
			value = '';
		}
		this.state={value};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({value: time2string(nextProps.value)});
	}

	handleChange(value) {
		this.setState({value});
	}

	handleBlur() {
		if (this.props.onChange) {
			this.props.onChange(this.state.value != '' ? string2time(this.state.value) : null, this);
		}
		if (this.props.onBlur) {
			this.props.onBlur(this.state.value != '' ? string2time(this.state.value) : null, this);
		}
	}

	render() {
		return (
			<Input {...this.props}
					value={this.state.value}
					onChange={(value) => this.handleChange(value)}
					onBlur={() => this.handleBlur()}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/TimeInput.js